import React, { useEffect, useState } from "react";
import { Autocomplete, Avatar, Box, Breadcrumbs, Button, Card, CardContent, Chip, Divider, FormHelperText, Grid2, IconButton, Link, List, ListItem, ListItemAvatar, ListItemText, ListSubheader, Stack, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { Formik } from "formik";
import * as Yup from 'yup';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, timelineOppositeContentClasses, TimelineSeparator } from "@mui/lab";
import { FaArrowRight, FaIndianRupeeSign, FaRegFileLines } from "react-icons/fa6";
import { useNavigate, useNavigationType, useParams } from "react-router-dom";
import { useDocumentDetailQuery } from "store/slices/apis/documentsSlice";
import moment from "moment";
import { API_END_POINT } from "config";
// import AddComment from "./AddComment";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useGetKeyIssueQuery } from "store/slices/apis/keyIssueSlice";
import { RxCross2 } from "react-icons/rx";
import HistoryTimeLine from "components/HistoryTimeLine";
import AddIssueComment from "./AddIssueComment";
import { FaRegEdit } from "react-icons/fa";
import EditIssue from "./EditIssue";
import { dispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { usePermission } from "hooks/usePermission";
import { KEY_ISSUE_ACCESS } from "config";
import { KEY_ISSUE_EDIT } from "config";
import { ReactComponent as LeftArrowicon } from "assets/PwC_Funct_Icons_ArrowLeft_Outline_Black_RGB.svg"

const issuesDetails = [
    {
        name: 'Category',
        field: 'package'
    },
    {
        name: 'Sub category 1',
        field: 'subPackage1'
    },
    {
        name: 'Sub category 2',
        field: 'subPackage2'
    },
    // {
    //     name: 'Sub category 3',
    //     field: 'subPackage3'
    // },
    // {
    //     name: 'Sub category 4',
    //     field: 'subPackage4'
    // },
    // {
    //     name: 'Sub category 5',
    //     field: 'subPackage5'
    // },
    // {
    //     name: 'Sub category 6',
    //     field: 'subPackage6'
    // },
    // {
    //     name: 'Sub category 7',
    //     field: 'subPackage7'
    // },
];

const issueColumns = [
    {
        name: 'Workflow name',
        field: 'workFlowName',
        renderer(params) {
            return (
                <Chip size="small" sx={{
                    fontSize: '12px',
                    '& .MuiChip-label': {
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        fontWeight: 600
                    }
                }} label={`${params ?? 'N/A'}`} />
            )
        }
    },
    {
        name: 'Consultant/Contractor',
        field: 'contactor_Name'
    },
    {
        name: 'Action required by',
        field: 'actionRequiredBy'
    },
    {
        name: 'Action required by email',
        field: 'actionRequiredByEmail'
    },
    {
        name: 'Current status',
        field: 'currentStatus',
        renderer(params) {
            return (
                <Chip size="small" sx={{
                    fontSize: '12px',
                    '& .MuiChip-label': {
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        fontWeight: 600
                    }
                }} label={`${params}`} />
            )
        }
    },
    {
        name: 'Time impact',
        field: 'timeImpact'
    },
    {
        name: 'Cost impact',
        field: 'costImpact',
        renderer(params) {
            return (

                <Stack direction="row" spacing={1}>
                    {params ?
                        <Chip icon={<FaIndianRupeeSign />} label={params} sx={{
                            backgroundColor: '#3E756D',
                            color: '#fff',
                            fontSize: '12px',
                            height: '18px',
                            '& .MuiChip-icon': {
                                color: '#fff'
                            },
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px'
                            }
                        }} />
                        : <Chip label="N/A" size="small" sx={{
                            fontSize: '12px',
                            '& .MuiChip-label': {
                                paddingLeft: '8px',
                                paddingRight: '8px'
                            }
                        }} />
                    }

                </Stack>
            );
        }
    },
    {
        name: 'Module',
        field: 'module'
    },
    {
        name: 'Severity',
        field: 'severity'
    },
    {
        name: 'Reporting Date',
        field: 'reportedDate',
        renderer(params) {
            return (
                <>
                    {params
                        ? moment(params).format("DD/MM/YY")
                        : "N.A."}
                </>
            );
        },
    },
]

const KeyIssueDetail = () => {

    const theme = useTheme();
    const navigate = useNavigate();
    const navigationType = useNavigationType();

    const { issueId, assignee, isEditable } = useParams();

    const decrypt = (encoded) => decodeURIComponent(escape(atob(encoded)));
    const decrypted = decrypt(assignee);

    const issueDetailRes = useGetKeyIssueQuery(issueId);
    const canApprove = usePermission(KEY_ISSUE_ACCESS);
    const canEdit = usePermission(KEY_ISSUE_EDIT);

    const [isEditIssueModal, setEditIssueModal] = useState(false);
    const [workflowStatus, setWorkflowStatus] = useState('N/A');
    const [rowData, setRowData] = useState(false);

    const handleEditIssue = (row) => {
        setEditIssueModal((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const openNotification = async (msg, type = 'error') => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>
                        <Tooltip
                            placement="bottom"
                            title="Back"
                            arrow
                            slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                            }}
                        >
                            {window.history.length > 1 && navigationType !== "POP" &&
                                <IconButton
                                    aria-label="download"
                                    size="small"
                                    onClick={() => {
                                        navigate(-1)
                                    }}
                                >
                                    <LeftArrowicon style={{ height: '22px', width: '22px', color: "#252525", stroke: "#252525", strokeWidth: 4 }} />
                                </IconButton>
                            }
                        </Tooltip>

                        Key Issue Detail
                    </Typography>
                </Box>
            </Grid2>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12}>
                    <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5 }}>
                        <Box sx={{ width: '100%', mb: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '20px',
                                    fontWeight: '500',
                                    color: '#252525',
                                    lineHeight: '32px',
                                    letterSpacing: '-0.4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                }}
                            >
                                {`Issue ID`}
                                <Chip
                                    label={`${issueDetailRes?.data?.data?.issueNumber}`}
                                    size="small"
                                    sx={{
                                        height: '20px',
                                        color: '#fff',
                                        fontSize: '12px',
                                        backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    }}
                                />
                            </Typography>
                            {/* {canEdit && issueDetailRes?.data?.data?.currentStatus != 'Close' && isEditable == 'true' &&
                                <Tooltip
                                    placement="top"
                                    title={"Edit"}
                                    arrow
                                    slotProps={{
                                        tooltip: { sx: { fontSize: "12px" } },
                                    }}
                                >
                                    <IconButton
                                        aria-label="Edit Issue"
                                        size="small"
                                        onClick={() => handleEditIssue(issueDetailRes?.data?.data)}
                                    >
                                        <FaRegEdit />
                                    </IconButton>
                                </Tooltip>
                            } */}

                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <CardContent sx={{ p: 0 }}>
                            <Grid2 container spacing={2}>
                                {issuesDetails?.map((val, index) => {
                                    return (
                                        <Grid2 size={{ xs: 12, md: 3, sm: 4 }}>
                                            <Typography variant="body1" sx={{ color: 'text.secondary' }}>{val?.name}</Typography>
                                            {val?.renderer ?
                                                val.renderer(issueDetailRes?.data?.data[val?.field])
                                                :
                                                <Typography gutterBottom variant="body2">{issueDetailRes?.data?.data[val?.field]}</Typography>
                                            }
                                        </Grid2>
                                    )
                                })}
                                <Grid2 size={{ xs: 12, md: 3, sm: 4 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Workflow status</Typography>
                                    {/* <Typography gutterBottom variant="body2">At RMC</Typography> */}
                                    <Chip size="small" sx={{
                                        fontSize: '12px',
                                        '& .MuiChip-label': {
                                            paddingLeft: '8px',
                                            paddingRight: '8px',
                                            fontWeight: 600
                                        }
                                    }} label={`${workflowStatus}`} />
                                </Grid2>
                                {issueColumns?.map((val, index) => {
                                    return (
                                        <Grid2 size={{ xs: 12, md: 3, sm: 4 }}>
                                            <Typography variant="body1" sx={{ color: 'text.secondary' }}>{val?.name}</Typography>
                                            {val?.renderer ?
                                                val.renderer(issueDetailRes?.data?.data[val?.field])
                                                :
                                                <Typography gutterBottom variant="body2">{issueDetailRes?.data?.data[val?.field]}</Typography>
                                            }
                                        </Grid2>
                                    )
                                })}
                                <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>Issue description</Typography>
                                    <Typography gutterBottom variant="body2">{issueDetailRes?.data?.data?.issueDescription}</Typography>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
                                    {issueDetailRes?.data?.data?.files?.length > 0 && (
                                        <>
                                            <List
                                                subheader={<ListSubheader sx={{ p: 0 }}>View Docuemnts</ListSubheader>}
                                            >
                                                {issueDetailRes?.data?.data?.files?.map(
                                                    (file, index) => (
                                                        <ListItem
                                                            key={index}
                                                            sx={{ padding: 0 }}
                                                        >
                                                            <ListItemAvatar>
                                                                <Avatar sx={{ background: "none" }}>
                                                                    <FaRegFileLines
                                                                        fontSize="inherit"
                                                                        style={{ color: "#474747" }}
                                                                    />
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={
                                                                    <span
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            color: "#474747",
                                                                            textDecoration: "underline",
                                                                        }}
                                                                        onClick={() => {
                                                                            window.open(
                                                                                `${API_END_POINT}issues/view/${file?.name}`,
                                                                                "_blank"
                                                                            );
                                                                        }}
                                                                    >
                                                                        {file?.name}
                                                                    </span>
                                                                }
                                                            />
                                                        </ListItem>
                                                    )
                                                )}
                                            </List>
                                        </>
                                    )}
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <HistoryTimeLine id={issueId} workflow={setWorkflowStatus} />
                </Grid2>
                {canApprove && decrypted == 'edit' && (
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Card sx={{ borderRadius: 1, boxShadow: 'none', p: 3, pt: 1.5, minHeight: '250px' }}>
                            <Box sx={{ width: '100%', mb: 1.5 }}>
                                <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '500', color: '#252525', lineHeight: "32px", letterSpacing: '-0.4px' }}>
                                    Add comment
                                </Typography>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <CardContent sx={{ p: 0 }}>
                                <AddIssueComment id={issueId} rowData={issueDetailRes?.data?.data} />
                            </CardContent>
                        </Card>
                    </Grid2>
                )}

            </Grid2 >

            {isEditIssueModal &&
                <EditIssue cancelIssue={handleEditIssue} open={isEditIssueModal} data={rowData} openNotification={openNotification} />
            }

        </>
    );
}

export default KeyIssueDetail;
